<template>
<div v-show='$store.state.educationDrawer'>

  <div class="close-drawer-section" @click="closeEducationDrawer()">
    
  </div>

  <div class="note-drawer-section">

  <!-- section -->
  <!-- non edit mode -->  
  <div v-show="!editMode" class="drawer-wrapper">

    <div class="note-drawer-title">
      Education Section 
      <span class="custom-edit-btn" v-show="!editMode" @click="editMode=true">Edit</span>
      <div class="close-drawer" @click="closeEducationDrawer()">
        <v-icon class="close-icon">fas fa-times</v-icon>
      </div>
    </div>

    <div class="note-drawer-container">
      

      <div class="education-main-title">      
        {{education.title}}
      </div>

      <iframe v-if='education.video' width="590" height="330" :src="findYoutubeId(education.video)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

      <div class="education-main-text" v-html="education.text">      
        
      </div>

      
    </div>
  </div>
    <!-- non edit mode end -->
    <!-- section -->

    <!-- section -->
    <!-- edit mode -->  
    <div v-show="editMode" class="drawer-wrapper">

      <div class="note-drawer-title">
        Education Section <span class="custom-edit-btn" @click="editMode=false">Close Edit</span>
        <div class="close-drawer" @click="closeEducationDrawer()">
          <v-icon class="close-icon">fas fa-times</v-icon>
        </div>
      </div>

      <div class="note-drawer-container">
        

        <div class="education-main-title">      
          Edit Education Module
        </div>

        <div class="education-form">

          <div class="education-li">
            <input type="text" v-model="education.title" placeholder="Title">
          </div>

          <div class="education-li">
            <input type="text" v-model="education.video" placeholder="Video Link">
          </div>

          <div class="education-li">
            <wysiwyg v-model="education.text" />
          </div>

          <div class="education-li">
            <div class="save-btn" @click="update()">Save</div>
          </div>

        </div>

        
      </div>
      </div>
      <!-- edit mode end -->
      <!-- section -->

  </div>

</div>
</template>

<script>
  import Vue from 'vue'
  import api from '@/api'

export default {
  name: 'Education-drawer',
  components: {
    
  },

  data () {
    return {
      editMode: false,
      education: {
        title: null,
        video: null,
        text: null
      }
    }
  },

  computed: {
    moduleEducationId () {
      return this.$store.state.educationModuleId
    },
    user () {
      return this.$store.getters.getUser
    },
  },

  watch: {
    moduleEducationId: function (val) {
      this.load()
    },
  },

  methods: {

    async load () {
      const response = await api.modules.education.get(this.moduleEducationId)
      if (response.status < 300) {
        this.education.title = response.data.title
        this.education.video = response.data.video
        this.education.text = response.data.text
      }
    },

    async update () {
      const response = await api.modules.education.update(this.education, this.moduleEducationId)
      if (response.status < 300) {
        console.log('response update', response.data)
      }
    },

    closeEducationDrawer () {
      this.$store.commit('closeEducationDrawer') // close drawer
      this.editMode = false
    },

    findYoutubeId (videoUrl) {

      var video_id = ''

      if (videoUrl.includes("youtube")) {
        video_id = videoUrl.split('v=').pop()
        console.log('video_id', video_id)
        var ampersandPosition = video_id.indexOf('&');
        if(ampersandPosition != -1) {
          video_id = video_id.substring(0, ampersandPosition);
        }

        return 'https://www.youtube.com/embed/' + video_id
      } 

      if (videoUrl.includes("vimeo")) {
        video_id = videoUrl.split('vimeo.com/').pop()
        console.log('video_id vimeo', video_id)
        var ampersandPosition = video_id.indexOf('&');
        if(ampersandPosition != -1) {
          video_id = video_id.substring(0, ampersandPosition);
        }

        return 'https://player.vimeo.com/video/' + video_id
      } 
    }

  },

  mounted () {
    this.load()
  }
}
</script>


<style lang="scss" scoped>
  .close-drawer-section {
    position: fixed;
    top: 0;
    left: 0;
    width: calc(100% - 700px);
    height: 100vh;
    background: rgba(0,0,0,0.4);
  }

  .note-drawer-section {
    position: fixed;
    top: 0;
    right: 0;
    width: 700px;
    height: 100vh;
    padding-top: 64px;
    border-left: 1px solid #eee;
    background: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 20px 0 rgba(0, 0, 0, 0.15);

    .drawer-wrapper {
      height: 95vh;
      overflow: auto;
    }

    .note-drawer-title {
      width: 100%;
      height: 56px;
      padding-left: 25px;
      padding-right: 25px;
      line-height: 58px;
      background: #f8f9fb;
      color: #9fa9bc;

      .custom-edit-btn {
        margin-left: 20px;
        color: #4C84FF;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          opacity: 0.75;
        }
      }

      .close-drawer {
        float: right;

        .close-icon {
          font-size: 18px;
          cursor: pointer;

          &:hover {
            opacity: 0.6;
          }
        }
      }
    }

    .note-drawer-container {
      margin-top: 25px;
      padding-left: 50px;
      padding-right: 50px;
      overflow: auto;

      .education-main-title {
        margin-bottom: 30px;
        font-size: 30px;
        font-weight: 600;
        text-align: center;
        color: #484848;
      }

      .education-form {

        .education-li {
          margin-bottom: 15px;

          input {
            width: 100%;
            height: 50px;
            padding-left: 15px;
            line-height: 50px;
            border: 1px solid #dedede;
            outline: none;
          }

          .save-btn {
            width: 150px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            border-radius: 3px;
            background: #4C84FF;
            color: #fff;
            cursor: pointer;
            transition: all 0.5s;

            &:hover {
              opacity: 0.75;
            }
          }
        }
      }

      .education-main-text {
        margin-top: 30px;
        line-height: 26px;
        color: #484848;
      }

      .left {
        float: left;
        width: 70%;
        font-size: 24px;
        font-weight: 600;

        input {
          outline: none;
        }
      }

      .right {
        float: right;
        margin-top: 3px;
        .status {

          .icon-dot {

          }

          .icon-progress {
            font-size: 16px;
          }

          .icon-text {
            padding-top: 2px;
            padding-left: 5px;
            font-family: 'Roboto', sans-serif;
            font-size: 12px !important;
            font-weight: 400;
            text-transform: capitalize;
            letter-spacing: 0;
            color: #9fa9bc;
          }

          .icon-arrow {
            font-size: 16px;
            padding-left: 5px;
            color: #9fa9bc;
          }
        }
      }
    }

    .note-description-section {
      margin-top: 25px;
      padding-left: 50px;
      padding-right: 50px;

      .description-title {
        font-size: 17px;
        color: #9fa9bc;
      }

      .description-textarea {

        textarea {
          width: 100%;
          min-height: 100px;
          padding: 10px;
          border: 1px solid #eef1f4;
          border-radius: 3px;
          background: #f6f7f9;
          outline: none;
        }
      }

      .description-default {
        width: 100%;
        min-height: 80px;
        padding: 10px;
        border-radius: 3px;
        cursor: pointer;
        transition: all 0.25s;

        &:hover {
          background: #eef0f4;
        }
      }

      .description-default-empty {
        background: #eef0f4 !important;
      }

      .description-active {

        .description-action-btns {
          height: 40px;

          .save {
            float: left;
            width: 80px;
            height: 40px;
            margin-right: 15px;
            line-height: 40px;
            text-align: center;
            border-radius: 3px;
            background: #1976d2;
            color: #fff;
            cursor: pointer;
            transition: all 0.25s;

            &:hover {
              opacity: 0.6;
            }
          }

          .cancel-icon {
            font-size: 26px;
            line-height: 40px;
            cursor: pointer;
            transition: all 0.25s;

            &:hover {
              opacity: 0.6;
            }
          }
        }
      }
    }

    .create-list-section {
      margin-top: 25px;
      padding-left: 50px;
      padding-right: 50px;

     .create-list-btn {
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      font-weight: 300;
      text-align: center;
      border: 1px solid #eef0f4;
      border-radius: 3px;
      background: #f6f7f9;
      color: #9fa9bc;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        opacity: 0.6;
      }
    }

    .create-list-types {
      border: 1px solid #eef0f4;
      border-radius: 3px;
      background: #f6f7f9;

      .create-list-title {
        width: 100%;
        margin-top: 15px;
        margin-bottom: 30px;
        text-align: center;
        font-size: 15px;
        font-weight: 600;
        color: #656e7e;
      }

      .create-list-inputs {
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 15px;

        .title-highlight {
          border: 1px solid #1976d2;
        }

        input {
          width: 100%;
          height: 40px;
          padding-left: 10px;
          padding-right: 10px;
          border: 1px solid #eef0f4;
          border-radius: 5px;
          background: #fff;
          outline: none;
        }
      }

      .create-list-title-active {
        background: #1976d2 !important;
        color: #fff !important;
      }

      .create-list-finish-btn {
        width: 200px;
        height: 40px;
        margin: auto;
        margin-bottom: 30px;
        line-height: 40px;
        text-align: center;
        border: 1px solid #eef0f4;
        border-radius: 5px;
        background: #eef0f4;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          background: #fff;
        }
      }

      .types-list {
        height: 160px;
        padding-left: 20px;
        overflow: auto;

        .type-li {
          float: left;
          width: 87px;
          height: 87px;
          margin-left: 12px;
          margin-right: 12px;

          .type-li-item {
            width: 100%;
            border: 1px solid #eef0f4;
            border-radius: 3px;
            background: #fff;
            cursor: pointer;

            .type-li-icon {
              width: 100%;
              font-size: 30px;
              text-align: center;
              line-height: 86px;
              color: #9fa9bc;
            }

            &:hover {
              border: 1px solid #6d9bff;

              .type-li-icon {
                color: #6d9bff;
              }
            }
          }

          .type-li-title {
            margin-top: 5px;
            font-size: 15px;
            text-align: center;
            color: #9fa9bc;
          }

          &:hover {
            .type-li-title {
              color: #6d9bff;
            }
          }
        }
      }
    }

    }

    .lists-section {
      margin-top: 30px;
      padding-left: 50px;
      padding-right: 50px;

      .image-form {
        margin-top: 45px;
        margin-bottom: 30px;

        #submitImage {
          display: none;
        }

        .submit-image-label {
          padding: 10px 20px 10px 20px;
          border-radius: 3px;
          background: #1976d2;
          color: #fff;
          cursor: pointer;
          transition: all 0.5s;

          &:hover {
            opacity: 0.6;
          }
        }

        .custom-submit-btn {
          background: red;
        }
      }

    }

    .images-section {
      overflow: auto;

      .image-padding {
        float: left;
        width: 33.33%;
        margin-top: 15px;
        padding-left: 10px;
        padding-right: 10px;
      }

      .image-li {
        width: 100%;

        img {
          width: 100%;
          cursor: pointer;
          transition: all 0.5s;

          &:hover {
            opacity: 0.7;
          }
        }
      }
    }

    .image-viewver {
      position: fixed;
      width: 100%;
      height: 100vh;
      top: 0;
      left: 0;
      background: rgba(0,0,0, 0.7);

      img {
        display: block;
        width: 50%;
        margin: auto;
        margin-top: 15%;
      }

      .close-viewver-icon {
        position: absolute;
        top: 85px;
        right: 22px;
        color: #fff;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          opacity: 0.6;
        }
      }
    }

  }
</style>